import { roundHalfUp } from '@sit/core';
const SECONDS_PER_HOUR = 60 * 60;
export const formatSecondsAsHours = (seconds) => {
    if (!seconds) {
        return '0.00';
    }
    return roundHalfUp(seconds / SECONDS_PER_HOUR, 2).toFixed(2);
};
export const getSecondsFromHours = (hours) => {
    if (typeof hours !== 'number') {
        return 0;
    }
    return Number(hours.toFixed(2)) * SECONDS_PER_HOUR;
};
export const getHoursFromSeconds = (seconds) => {
    if (seconds === null) {
        return 0.0;
    }
    return roundHalfUp(Number(seconds) / SECONDS_PER_HOUR, 2);
};
export const formatHours = (hours) => {
    if (hours === null) {
        return '0.00';
    }
    if (typeof hours === 'string') {
        return Number.parseFloat(hours).toFixed(2);
    }
    return hours.toFixed(2);
};
//# sourceMappingURL=duration.js.map